import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_43 implements Validator {

	public static id = 'CTRL_43';
	private message = 'error.ctr_43';


	public LOG: LogService = new LogService(CTRL_43);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		                          const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_43.id + '_');


		                          if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const controls =
					this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);

				const firstWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
				const secondWithStepId = ctrl.value.rgCtrls.secondChamp;
				const thirdWithStepId = ctrl.value.rgCtrls.thirdChamp;
				const fourthWithStepId = map.get(ctrl.value.rgCtrls.fourthChamp);
				const fifthWithStepId = map.get(ctrl.value.rgCtrls.fifthChamp);
				const sixthWithStepId = map.get(ctrl.value.rgCtrls.sixthChamp);
				const seventhWithStepId = map.get(ctrl.value.rgCtrls.seventhChamp);
				const eigththWithStepId = map.get(ctrl.value.rgCtrls.eigththChamp);
				const ninthWithStepId = map.get(ctrl.value.rgCtrls.ninthChamp);
				const firstCtrl = form.controls[firstWithStepId];
				const fourthCtrl = form.controls[fourthWithStepId];
				const fifthCtrl = form.controls[fifthWithStepId];
				const sixthCtrl = form.controls[sixthWithStepId];
				const seventhCtrl = form.controls[seventhWithStepId];
				const eigththCtrl = form.controls[eigththWithStepId];
				const ninthCtrl = form.controls[ninthWithStepId];

				let controlsName = [];
				const secondIters = this.formExtractorService.getIndexes(
					Array.from(controls.keys()), ['_SepAtt_cp'], secondWithStepId.split('INDEX')[0]);
				for (let i = 1; i <= secondIters.size; i++) {
					controlsName.push(secondWithStepId.replace('INDEX_43_1', i));
				}
				const valuesSecond = [];
				for (let i = 0; i < controlsName.length; i++) {
					valuesSecond.push(!this.isCorrect(form.controls[map.get(controlsName[i])].value));
				}

				controlsName = [];
				const thirdIters = this.formExtractorService.getIndexes(
					Array.from(controls.keys()), ['_SepAtt_cp'], thirdWithStepId.split('INDEX')[0]);
				for (let i = 1; i <= thirdIters.size; i++) {
					controlsName.push(thirdWithStepId.replace('INDEX_43_1', i));
				}
				const valuesThird: boolean[] = [];
				for (let i = 0; i < controlsName.length; i++) {
					valuesThird.push(!this.isCorrect(form.controls[map.get(controlsName[i])].value));
				}


				if (!this.isCorrect(firstCtrl.value) ||
					valuesSecond.indexOf(true) !== -1 ||
					valuesThird.indexOf(true) !== -1 ||
					!this.isCorrect(fourthCtrl.value) ||
					!this.isCorrect(fifthCtrl.value) ||
					!this.isCorrect(sixthCtrl.value) ||
					!this.isCorrect(seventhCtrl.value) ||
					!this.isCorrect(eigththCtrl.value) ||
					!this.isCorrect(ninthCtrl.value)) {

					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}

	isCorrect(value): boolean {
		if (value) {
			return value.match(/^[0-9][0-9][0-9][0-9][0-9]/) !== null && value.length === 5;
		}
		return false;
	}
}
